import { Alert, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect } from 'react-use';
import { getManagerRobotId, getUserId, Log } from '../common/util';
import NewPage from '../components/NewPage';
import RobotDisturbInputForm from '../components/robot/RobotDisturbInputForm';
import RobotGeoInputForm from '../components/robot/RobotGeoInputForm';
import RobotReactionInputForm from '../components/robot/RobotReactionInputForm';
import SliderInputForm from '../components/robot/SliderInputForm';
import Toast from '../components/Toast';
import { configUpdate, getConfigData } from '../modules/privateManager';
import {
  getPiboInfo,
  setGroup,
  setPiboDisturb,
  setPiboGeo,
  setPiboReaction,
  setPiboVolume,
} from '../pibo';

const PrivateConfigPage = ({ menu }) => {
  const dispatch = useDispatch();
  const {
    config: { item, result, error, message },
  } = useSelector((state) => state.private);
  const [itemInfo, setInfo] = useState({
    alias: null,
    serial: null,
    reaction: null,
    geo: null,
    info: null,
  });
  const [snack, setSnack] = useState({ open: false });
  const { id: robotId, serial, reaction, geo, info, disturb } = itemInfo;

  const handleVolumeChange = (v, s) => {
    setGroup([s]);
    setPiboVolume(v);
  };

  const handleReactionChange = (v) => {
    dispatch(configUpdate({ reaction: v, robotId }));
    setPiboReaction(v);
  };

  const handleGeoChange = (v) => {
    dispatch(configUpdate({ geo: v, robotId }));
    setPiboGeo(v);
  };

  const onDisturbChange = (v) => {
    dispatch(configUpdate({ disturb: { ...v, userId: getUserId() }, robotId }));
    setPiboDisturb(v);
  };

  useEffect(() => {
    if (item) {
      setGroup([serial]);
      setInfo({ ...item, info: null });
      getPiboInfo()
        .then((data) => {
          const { config } = data;
          // setInfo({ ...items[0], info: config });
          setInfo((prevState) => ({ ...prevState, info: config }));
        })
        .catch((e) => {
          Log(e);
        });
    }
  }, [item]);

  useUpdateEffect(() => {
    if (result) {
      setSnack({
        open: true,
        onClose: () => setSnack({ open: false }),
        message,
        severity: 'success',
      });
    } else if (error) {
      setSnack({
        open: true,
        onClose: () => setSnack({ open: false }),
        message: error,
        severity: 'error',
      });
    }
  }, [result]);

  useUpdateEffect(() => {
    if (menu === 'config') {
      dispatch(getConfigData(getManagerRobotId()));
    }
  }, [menu]);

  useMount(() => {
    dispatch(getConfigData(getManagerRobotId()));
  });

  return (
    <NewPage title="로봇 설정">
      <Grid item xs={12} display="inline-flex" alignItems="center">
        <Alert severity="info" sx={{ width: '100%' }}>
          볼륨 설정을 제외한 설정은 카드 우측의 &ldquo;저장&rdquo; 버튼을 각각
          선택하여 저장해야 합니다.
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <SliderInputForm
          id="slider"
          name="slider"
          defaultValue={info ? info.volume : 60}
          max={100}
          min={0}
          step={1}
          onChange={(v) => handleVolumeChange(v, serial)}
          readOnly={!info}
        />
      </Grid>
      <Grid item xs={12}>
        <RobotReactionInputForm
          id="reaction"
          name="reaction"
          value={reaction || 0}
          onSave={handleReactionChange}
        />
      </Grid>
      {geo && (
        <Grid item xs={12}>
          <RobotGeoInputForm
            id="location_search"
            name="location_search"
            value={geo}
            onSave={handleGeoChange}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <RobotDisturbInputForm value={disturb} onSave={onDisturbChange} />
      </Grid>
      <Toast {...{ ...snack }} />
    </NewPage>
  );
};

export default PrivateConfigPage;
